import type { AvatarProps } from '@mui/material';
import { Avatar } from '@mui/material';
import { ProfileIcon } from '@tix-ticketing/ui-icons/filled';
const sizeVariants = {
  small: {
    diameter: 40,
    typography: 'body1Bold' as const,
    fontSize: undefined,
    iconSize: 20
  },
  large: {
    diameter: 64,
    typography: 'h5' as const,
    fontSize: 22,
    iconSize: 32
  }
} as const;
interface UserAvatarProps extends Omit<AvatarProps, 'children'> {
  /** Initials shown inside the avatar. Falls back to a profile icon when empty. */
  initials: string;
  size?: keyof typeof sizeVariants;
}
export const UserAvatar = ({
  initials,
  size = 'small',
  sx,
  ...props
}: UserAvatarProps) => {
  const variant = sizeVariants[size];
  return <Avatar {...props} sx={[theme => ({
    bgcolor: 'primary.main',
    color: 'primary.contrastText',
    width: variant.diameter,
    height: variant.diameter,
    // A circle on the default theme, square-ish where buttons are.
    borderRadius: `${theme.buttonRadius.main}px`,
    ...theme.typography[variant.typography],
    fontSize: variant.fontSize
  }), ...(Array.isArray(sx) ? sx : [sx])]}>
      {initials || <ProfileIcon sx={{
      fontSize: variant.iconSize
    }} />}
    </Avatar>;
};